import React from "react";
import AuthorityPage from "@/components/AuthorityPage";
import { METHODOLOGY } from "@/lib/authorityContent";

export default function Methodology() {
  return <AuthorityPage {...METHODOLOGY} pageType="WebPage" testid="methodology-page" />;
}
